import { render } from "./CounselorModal.vue?vue&type=template&id=591d995a&scoped=true"
import script from "./CounselorModal.vue?vue&type=script&lang=js"
export * from "./CounselorModal.vue?vue&type=script&lang=js"

import "./CounselorModal.vue?vue&type=style&index=0&id=591d995a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591d995a"]])

export default __exports__